/**
 * useDeploymentDetails.ts
 *
 * Fetches deployment details (assets) on mount for both summary & running modes.
 * Stores the response in deploymentData via GenericSimulatorContext.
 */

import { useEffect } from 'react';
import useGenericSimulator from './useGenericSimulator';
import useUrlParams from './useUrlParams';
import { getDeploymentDetails } from '../service/GenericSimulatorApi';

const useDeploymentDetails = () => {
    const { deploymentData, setDeploymentData, setLoading } = useGenericSimulator();
    const { mission_id, scenario_id } = useUrlParams();

    useEffect(() => {
        if (!mission_id || !scenario_id) return;

        const fetchDeploymentDetails = async () => {
            try {
                setLoading(true);
                const response = await getDeploymentDetails(mission_id, scenario_id);
                setDeploymentData(response?.data || null);
            } catch (error) {
                setDeploymentData(null);
            } finally {
                setLoading(false);
            }
        };

        fetchDeploymentDetails();
    }, [mission_id, scenario_id]); // eslint-disable-line react-hooks/exhaustive-deps

    return { deploymentData };
};

export default useDeploymentDetails;
